import { basePath } from "@Common/constants";
import { thanksResponsesPath } from "@Src/constants";
import { type ReactNode, useEffect } from "react";
import { useRecordContext } from "react-admin";
import { useNavigate } from "react-router-dom";

interface FormRedirectionWrapperProps {
	children: ReactNode;
}

export const FormRedirectionWrapper = ({
	children,
}: FormRedirectionWrapperProps) => {
	const navigate = useNavigate();
	const record = useRecordContext();

	// NOTE: we never re-send the email to submit responses
	// + we made the response link single-use so there is no really real situation anymore
	// where this logic would kick in
	useEffect(() => {
		if (record?.["is_submitted"] === true) {
			navigate(`${basePath}${thanksResponsesPath}`);
		}
	}, [record, navigate]);

	return <>{children}</>;
};
